import PropTypes from "prop-types"
import React, {useState} from "react"
import Styled, {css, keyframes} from "styled-components"
import {navigate} from "gatsby"
import {ContainerFluid, Container, Row, Col} from "@uprise/grid"
import {spacing} from "@uprise/spacing"
import {extended, backgrounds} from "@uprise/colors"
import {text} from "@uprise/typography"
import {Button} from "@uprise/button"

// Components
import DropDown from "./DropDown"
import Link from "./Link"

const slideIn = keyframes`
	0% {
		left: -250px;
	}

	100% {
		left: 0;
	}
`

const HeaderTransparentWrapper = Styled.div`
      position: absolute;
	  width: 100%;
	  z-index: 101;
`

const Header = Styled.header`
	position: relative;
	display: flex;
	flex-direction: row;
	padding: 20px 0px 20px 0;
	height: 40px;

	@media (max-width: 1024px) {
		${props => {
			if (props.show) {
				return css`
					position: fixed;
					flex-direction: column;
					justify-content: flex-start;
					left: 0;
					top: 0;
					height: 100%;
					background: ${extended.purple.dark};
					// width: 320px;
					width: 100%;
					z-index: 10;
					opacity: 0.97;
					animation: 0.2s ${slideIn} ease-out;
				`
			}
		}}
	}
`

const Menu = Styled.section`
	width: 100%;
	display: flex;
	justify-content: space-between;

	@media (max-width: 1024px) {
		display: ${props => (props.show ? "block" : "none")};
	}
`

const MobileMenuIconWhite = Styled.section`
	display: none;

	@media (max-width: 1024px) {
		position: absolute;
		display: block;
		background-image: url(${require("../../images/icons/menu-purple.svg")});
		background-repeat: no-repeat;
		background-size: contain;
		margin-top: 10px;
		width: 32px;
		height: 32px;
		cursor: pointer;

		${props => {
			if (props.show) {
				return `
					background-image: url(${require("../../images/icons/close-purple.svg")});
					align-self: flex-end;
					top: 15px;
					right: 15px;
					width: 25px;
					height: 25px;
					position: absolute;
				`
			}
		}}
	}

	@media (max-width: 475px) {
		width: 25px;
		height: 25px;
	}
`

const MobileMenuIcon = Styled.section`
	display: none;

	@media (max-width: 1024px) {
		position: absolute;
		display: block;
		background-image: url(${require("../../images/icons/menu-white.svg")});
		background-repeat: no-repeat;
		background-size: contain;
		margin-top: 10px;
		width: 32px;
		height: 32px;
		cursor: pointer;

		${props => {
			if (props.show) {
				return `
					background-image: url(${require("../../images/icons/close-white.svg")});
					align-self: flex-end;
					top: 15px;
					right: 15px;
					width: 25px;
					height: 25px;
					position: absolute;
				`
			}
		}}
	}

	@media (max-width: 475px) {
		width: 25px;
		height: 25px;
	}
`

const Logo = Styled.img`
    width: 106px;
	height: 30px;
	&:hover {
		cursor: pointer;
	}

	@media (max-width: 1024px) {
		margin: 0 auto;
		${props => {
			if (props.show) {
				return `
					margin-left: ${spacing.s10};
				`
			}
		}}
	}
`

const MenuLeft = Styled.div`
    display: flex;
	flex-direction: row;
`

const MenuRight = Styled.div`
	@media (max-width: 1024px) {
		flex-direction: column;
		// margin-top: 350px;
		margin-top: 30px;
	}
`

const MenuItemsLeft = Styled.nav`
    height: 24px;
    display: flex;
	margin-left: ${spacing.s7};
	
	@media (max-width: 1024px) {
		width: 100%;
		margin-top: ${spacing.s10};
		flex-direction: column;
		// height: 130px;
		height: auto;
		justify-content: space-between;
 	}
`

const MenuItemsRight = Styled.nav`
    height: 24px;
    display: flex;
	justify-content: flex-end;
	
	@media (max-width: 1024px) {
		flex-direction: column;
		justify-content: space-between;
		margin-left: ${spacing.s10};
		height: 100px;
	}
`

const HeaderTransparent = ({type, sharedNavitems, navitems}) => {
	const [showMobileMenu, setShowMobileMenu] = useState(false)
	const logo = navitems.filter(item => item.type === "LOGO")[0]
	const navLeft = sharedNavitems?.filter(item => (!item.RHS && item.type === "DROP_DOWN") || item.type === "LINK")
	const navRight = sharedNavitems?.filter(item => item.RHS || item.type === "BUTTON")
	const _handleMobile = () => {
		setShowMobileMenu(!showMobileMenu)
	}

	return (
		<HeaderTransparentWrapper
			style={type === "default" && {background: "white", position: "relative", height: "80px"}}>
			<ContainerFluid>
				<Container>
					<Row>
						<Col>
							<Header show={showMobileMenu} style={type === "default" && {background: backgrounds.white}}>
								<Logo
									className='m-t-1'
									src={logo.image}
									alt='Uprise logo'
									show={showMobileMenu}
									onClick={() => window.location.replace("https://uprise.co/")}
									width='106'
									height='30'
								/>
								{type === "default" ? (
									<MobileMenuIconWhite onClick={() => _handleMobile()} show={showMobileMenu} />
								) : (
									<MobileMenuIcon onClick={() => _handleMobile()} show={showMobileMenu} />
								)}

								<Menu show={showMobileMenu}>
									<MenuLeft>
										<MenuItemsLeft>
											{navLeft.map((item, index) => {
												if (item.type === "DROP_DOWN") {
													return (
														<DropDown
															key={index}
															dropdown={item}
															color={
																type === "default"
																	? extended.charcoal.one
																	: backgrounds.white
															}
															white={type === "default" ? false : true}
															margin='10px 15px 10px 15px'
															fontSize={text.t5}
															fontSizeHover={text.t6}
															icon={
																type === "default"
																	? "uprise-dropdown-default.svg"
																	: "uprise-dropdown.svg"
															}
														/>
													)
												} else if (item.type === "LINK") {
													return (
														<Link
															key={index}
															link={item}
															color={
																type === "default"
																	? `${extended.charcoal.one} !important`
																	: backgrounds.white
															}
															margin='10px 15px 10px 15px'
															fontSize={text.t5}
														/>
													)
												}
											})}
										</MenuItemsLeft>
									</MenuLeft>
									<MenuRight>
										<MenuItemsRight>
											<Button
												className='m-r-5'
												title={navRight[0].action[0].label}
												onClick={() => window.location.replace(`${navRight[0].action[0].link}`)}
												variant='tertiary'
												uppercase={true}
												transparent={type === "default" ? false : true}
												borderRadius='5px'
												size='medium'
												width='80px'
											/>
											<Button
												className=''
												title={navRight[1].action[0].label}
												onClick={() => navigate(navRight[1].action[0].link)}
												variant='secondary'
												width='136px'
												uppercase={true}
												transparent={type === "default" ? false : true}
												borderRadius='5px'
												size='medium'
											/>
										</MenuItemsRight>
									</MenuRight>
								</Menu>
							</Header>
						</Col>
					</Row>
				</Container>
			</ContainerFluid>
		</HeaderTransparentWrapper>
	)
}

export default HeaderTransparent
